import { useAuthStore } from '@/pinia/auth'
import { useBrandedStore } from '@/pinia/branded'
import { useStyleStore } from '@/pinia/style'

const routes = [
  {
    path: '/clear',
    name: 'Clear Session',
    meta: { authFlow: true },
    beforeEnter: (to, from, next) => {
      const authStore = useAuthStore()
      next({ path: 'logout', query: { path: authStore.login_url, isPurge: true } })
    }
  },
  {
    path: '/launch/:slug',
    name: 'Design Online',
    meta: { brandedLaunch: true },
    component: () => import('@/views/Public/Launch.vue'),
    beforeEnter: (to, from, next) => {
      const authStore = useAuthStore()
      const brandedStore = useBrandedStore()
      if (authStore.usingBrandedModeToken && to.params.slug === brandedStore.slug) {
        next(`/${brandedStore.slug}/choose-product`)
      } else {
        next()
      }
    }
  },
  {
    path: '/launch/:slug/disabled',
    name: 'Design Online Disabled',
    meta: { brandedLaunch: true },
    component: () => import('@/views/Public/LaunchDisabled.vue')
  },
  {
    path: '/:slug/thanks',
    name: 'Design Online - Thank You',
    component: () => import('@/views/Branded/ThankYou.vue')
  },
  {
    path: '/password-reset',
    name: 'Reset Password',
    component: () => import('@/views/Public/PasswordReset.vue')
  },
  {
    path: '/new-user',
    name: 'Set Password',
    component: () => import('@/views/Public/NewUserSetPassword.vue')
  },
  {
    path: '/tmp/show-thumbs',
    meta: { active: 'branded-prices' },
    component: () => import('@/components/shared/pricing/PricingInfo.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Public/Register.vue'),
    meta: { authFlow: true },
    beforeEnter: (to, from, next) => {
      const styleStore = useStyleStore()
      if (styleStore.fabricator?.name === 'BM Express Tenant') {
        next('/')
      } else {
        next()
      }
    }
  },
  {
    path: '/verify-email',
    name: 'Verify Email',
    redirect: '/Register'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Public/Login.vue'),
    meta: { authFlow: true },
    beforeEnter: (to, from, next) => {
      const authStore = useAuthStore()
      if (authStore.loggedIn) {
        next('/')
      } else {
        next()
      }
    }
  },
  {
    path: '/login-admin',
    name: 'Super User Login',
    component: () => import('@/views/Public/TouchSuperUserLogin.vue'),
    meta: { authFlow: true },
    beforeEnter: (to, from, next) => {
      const authStore = useAuthStore()
      if (authStore.loggedIn) {
        next('/')
      } else {
        next()
      }
    }
  },
  {
    path: '/logout',
    name: 'Logout',
    component: () => import('@/views/Public/Logout.vue'),
    meta: { authFlow: true }
  },
  {
    path: '/error/:eventId',
    name: 'Error',
    component: () => import('@/views/Public/ErrorMessage500.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if (from?.name) {
        next()
      } else {
        next('/')
      }
    }
  }
]

export default routes.map((route) => {
  const meta = { ...route.meta, app: 'public' }
  return { ...route, meta }
})
